import u from "./index216.mjs";
import v from "./index215.mjs";
import b from "./index237.mjs";
import O from "./index238.mjs";
import C from "./index239.mjs";
import E from "./index240.mjs";
import I from "./index241.mjs";
import _ from "./index242.mjs";
import N from "./index234.mjs";
import S from "./index243.mjs";
import p from "./index244.mjs";
import k from "./index245.mjs";
import T from "./index246.mjs";
import M from "./index232.mjs";
const V = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function B(s = {}, ...d) {
  const {
    mixins: h = {},
    palette: y = {},
    transitions: x = {},
    typography: g = {}
  } = s, a = v(s, V);
  if (s.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  s.generateCssVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : N(18));
  const c = O(y), m = S(s);
  let e = p(m, {
    mixins: b(m.breakpoints, h),
    palette: c,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: E.slice(),
    typography: C(c, g),
    transitions: I(x),
    zIndex: u({}, _)
  });
  if (e = p(e, a), e = d.reduce((i, o) => p(i, o), e), process.env.NODE_ENV !== "production") {
    const i = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], o = (t, n) => {
      let r;
      for (r in t) {
        const f = t[r];
        if (i.indexOf(r) !== -1 && Object.keys(f).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const l = M("", r);
            console.error([`MUI: The \`${n}\` component increases the CSS specificity of the \`${r}\` internal state.`, "You can not override it like this: ", JSON.stringify(t, null, 2), "", `Instead, you need to use the '&.${l}' syntax:`, JSON.stringify({
              root: {
                [`&.${l}`]: f
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          t[r] = {};
        }
      }
    };
    Object.keys(e.components).forEach((t) => {
      const n = e.components[t].styleOverrides;
      n && t.indexOf("Mui") === 0 && o(n, t);
    });
  }
  return e.unstable_sxConfig = u({}, k, a == null ? void 0 : a.unstable_sxConfig), e.unstable_sx = function(o) {
    return T({
      sx: o,
      theme: this
    });
  }, e;
}
export {
  B as default
};
